import {
  Lci3Report,
  Lci3SalesMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { clampNegativeToZero } from '@utils/valueTransformers';
import { SplineChartOptionsProps } from '../configuration/splineChartOptions';

export const reportsToSeriesData = (
  options: {
    reports: Lci3Report[];
  } & (
    | {
        type: 'visit';
        field: keyof Pick<
          Lci3Report['visitMetrics'],
          | 'incrementalLift'
          | 'incrementalVisits'
          | 'impressions'
          | 'uniqueUsers'
        >;
      }
    | {
        type: 'sales';
        field: keyof Pick<
          Lci3SalesMetrics,
          'incrementalSalesLift' | 'incrementalSales' | 'totalProjectedSales'
        >;
      }
  )
): SplineChartOptionsProps['data'] =>
  options.reports
    .map(report => ({
      date: report.reportDate,
      value: clampNegativeToZero(
        options.type === 'visit'
          ? (report.visitMetrics[options.field] ?? 0)
          : (report.salesMetrics?.[options.field].total ?? 0)
      ),
    }))
    .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
